import React, { Component } from 'react';
import ConnectorStartEndPoint from './connector-components/start-end-point';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import GraphicLineEditor from './connector-components/graphic-line-editor';
import omit from 'lodash/omit';
import { mobxSet, omitStyle } from '@src/slide/infrastructure/module/independent/assert/get-set';
import SelectedElementWrapperUtil from '../utils';
import { observer } from 'mobx-react';
import * as commonFun from '../../../common';
import ObserverFactory from '@src/slide/application/service/modelObserver/observerFactory';
import ConnectorStartEndPointMobile from './connector-components/start-end-point-mobile';
import GraphicLineEditorMobile from './connector-components/graphic-line-editor-mobile';
import { ServicesContext } from '../../context';
import { IConnectorModel } from '@src/slide/domain/ui-model/element-modeles/Interface/connector-model.interface';
import type { SelectElementWrapper } from '@src/framework/editor/src/page/index/components/canvas/edit-panel/selected-element-layer/selected-ele-wrapper-factory';

interface SelectedConnectorWrapperProps extends SelectElementWrapper {
    element: IConnectorModel;
    scale: number;
    editable: boolean;
    isPreview: boolean;
    isConnecting: boolean;
}

@observer
class SelectedConnectorWrapper extends Component<SelectedConnectorWrapperProps> {
    public static contextType = ServicesContext;

    public componentDidMount() {
        const observer = ObserverFactory.createObserver(this.props.element);
        if (observer) {
            observer.addChangesetObserver(this.updateComponent);
        }
    }

    public updateComponent = () => {
        this.forceUpdate();
    };

    public componentWillUnmount() {
        const observer = ObserverFactory.createObserver(this.props.element);
        if (observer) {
            observer.removeChangesetObserver(this.updateComponent);
        }
    }

    public render() {
        if (this.context.editingStateManager.isConnecting && !browser.isMobile) return null;
        const elementModel = this.props.element;
        const frameWithOp = elementModel.getFrame?.().getFrameInfo(true);
        const controlValues = elementModel.operatingGraphicInfo
            ? elementModel.operatingGraphicInfo.controlValues
            : elementModel.props.style.controlValues;
        return (
            <React.Fragment>
                {
                    this.props.editable
                    && !this.props.isPreview
                    && (
                        !(browser.isMobile) ? <ConnectorStartEndPoint
                            element={elementModel}
                            scale={this.props.scale} /> : <ConnectorStartEndPointMobile
                            element={elementModel}
                            isConnecting={this.props.isConnecting}
                            scale={this.props.scale} />
                    )
                }
                {
                    this.props.editable
                    && !this.props.isPreview
                    && <div
                        style={{
                            width: '100%',
                            height: '100%',
                            position: 'absolute',
                            transform: commonFun.transformOfFlip(frameWithOp),
                            pointerEvents: 'none',
                        }}
                    >
                        {
                            !(browser.isMobile) ? <GraphicLineEditor
                                model={{
                                    ...omit(omitStyle(this.props.element.props.style), 'width', 'height'),
                                    width: frameWithOp.width,
                                    height: frameWithOp.height,
                                    controlValues,
                                }}
                                scale={this.props.scale}
                                onControlValueChange={this.handleControlValuesChange}
                                onControlPointMoving={this.handleControlPointMoving}
                            >
                            </GraphicLineEditor> : <GraphicLineEditorMobile
                                model={{
                                    ...omit(omitStyle(this.props.element.props.style), 'width', 'height'),
                                    width: frameWithOp.width,
                                    height: frameWithOp.height,
                                    controlValues,
                                }}
                                scale={this.props.scale}
                                isConnecting={this.props.isConnecting}
                                onControlValueChange={this.handleControlValuesChange}
                                onControlPointMoving={this.handleControlPointMoving}
                            >
                            </GraphicLineEditorMobile>
                        }

                    </div>
                }
            </React.Fragment>
        );
    }

    private handleControlPointMoving = (controlValues) => {
        if (!SelectedElementWrapperUtil
            .checkControlValuesSame(
                this.props.element.props.style.controlValues,
                controlValues,
            )) {
            mobxSet(this.props.element, 'operatingGraphicInfo', {
                controlValues,
            });
        }
    };

    private handleControlValuesChange = (newControlValues) => {
        const graphicInfo = {
            controlValues: newControlValues,
        };
        if (this.props.element) {
            this.props.element.getGraphic()?.updateGraphicLineInfo(graphicInfo);
        }
        this.props.element.operatingGraphicInfo = null;
    };
}

export default SelectedConnectorWrapper;
